module.exports = __webpack_public_path__ + "media/images/country_flags/nr-8320b9e772cf8d62138c336c4da14d54.png";